var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUserOnlineIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 12,
    viewBox: "0 0 10 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.28 9.92969C10.28 10.4974 10.1172 10.9844 9.79172 11.3906C9.4662 11.7969 9.07427 12 8.61594 12H1.94406C1.48573 12 1.0938 11.7969 0.76828 11.3906C0.442759 10.9844 0.279999 10.4974 0.279999 9.92969C0.279999 9.48698 0.302134 9.06901 0.346405 8.67578C0.390676 8.28255 0.472707 7.88672 0.592499 7.48828C0.71229 7.08984 0.864634 6.7487 1.04953 6.46484C1.23443 6.18099 1.47922 5.94922 1.78391 5.76953C2.08859 5.58984 2.43885 5.5 2.83469 5.5C3.51698 6.16667 4.33208 6.5 5.28 6.5C6.22792 6.5 7.04302 6.16667 7.72531 5.5C8.12114 5.5 8.47141 5.58984 8.77609 5.76953C9.08078 5.94922 9.32557 6.18099 9.51047 6.46484C9.69536 6.7487 9.84771 7.08984 9.9675 7.48828C10.0873 7.88672 10.1693 8.28255 10.2136 8.67578C10.2579 9.06901 10.28 9.48698 10.28 9.92969ZM7.40109 0.878906C7.40109 0.878906 7.54758 1.02539 7.84055 1.31836C8.13351 1.61133 8.28 2.17188 8.28 3C8.28 3.82812 7.98703 4.53516 7.40109 5.12109C6.81516 5.70703 6.10812 6 5.28 6C4.45187 6 3.74484 5.70703 3.15891 5.12109C2.57297 4.53516 2.28 3.82812 2.28 3C2.28 2.17188 2.57297 1.46484 3.15891 0.878906C3.74484 0.292969 4.45187 0 5.28 0C6.10812 0 6.81516 0.292969 7.40109 0.878906Z",
    fill: "#00B300"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserOnlineIcon);
export default __webpack_public_path__ + "static/media/user-online-icon.1a59da4f308d7018e3bde0470c4a0051.svg";
export { ForwardRef as ReactComponent };